import { useEffect, useRef } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import 'ol/ol.css'

import { MapProvider, useMap } from '@/lib/ol-cleaned-lib'

// Tamil Nadu center [lon, lat]
const TN_CENTER: [number, number] = [78.6569, 10.8505]

export const Route = createFileRoute('/map')({
  component: MapRoute,
})

function MapRoute() {
  return (
    <MapProvider center={TN_CENTER} initialZoom={7}>
      <MapCanvas />
    </MapProvider>
  )
}

function MapCanvas() {
  const mapRef = useRef<HTMLDivElement>(null)
  const { map } = useMap()

  useEffect(() => {
    if (!map || !mapRef.current) {return}
    map.setTarget(mapRef.current)
    map.updateSize()
    return () => map.setTarget(undefined)
  }, [map])

  return <div ref={mapRef} className="h-screen w-screen" />
}
